//
// Class representing an auction.
function ANInjector(zoneDelegate, videoLibrary, logger){

    this.__zoneDelegate          = zoneDelegate;
    this.__videoLibrary          = videoLibrary;
    this.__numberOfInjectedZones = {}; // Move this to zone manager.
    this.__rails                 = {};
    this.__logger                = logger || new AdsNinjaLogger();
    this.__hasRun                = false;
    this.__densityManagers       = {};
    this.__distanceHelpers       = {};
    this.__monetizeContentQueues = {};

    // Constants.
    this.SECONDARY_INJECTION_TABLE_MIN_ROWS    = 14; // TODO: Make this configurable.
    this.SECONDARY_INJECTION_TABLE_BUFFER_ROWS = 7;
    this.SECONDARY_INJECTION_LIST_MIN_ROWS     = 10;
    this.SECONDARY_INJECTION_LIST_BUFFER_ROWS  = 5;
    this.CONTINUOUS_BLOCK_MARGIN_PX            = 500;
}

//
// Run method.
ANInjector.prototype.run = function(data, isPageLoad = false){

    if(!data || this.__hasRun){

        return;
    }

    // Find zones that have pixel repeatable settings.
    var zones = this.__zoneDelegate.getRepeatableZones(); // TODO: Validate condition.

    for(var i = 0; i < zones.length; i++){

        var zone               = zones[i];
        var repeatableSettings = zone.getRepeatableSettings();

        if(!repeatableSettings || !repeatableSettings.hasOwnProperty('type') || ('pixelCount' !== repeatableSettings.type && 'density' !== repeatableSettings.type)){

            continue;
        }

        // TODO: Use these classes where nessary.
        // an-injection-repeatable-avoid-before
        // an-injection-repeatable-avoid-inside
        // an-injection-repeatable-avoid-after

        // TODO: Move this out of here.
        var repeatableRules = {
            transparent: [
                // { type: 'tag', selection: 'div'     }, // Avoid all divs.
                { type: 'class', selection: 'content-block-regular' }, // TODO: Make this configurable.
                // { type: 'tag',   selection: 'section'                }, // Avoid all sections.
                // { type: 'tag',   selection: 'article'                },
                // { type: 'tag',   selection: 'main'                   },
                // { type: 'tag',   selection: 'body'                   },
                { type: 'id',   selection: 'article-body'            },

                // For now.
                // { type: 'tag',   selection: 'table'                                },
                // { type: 'tag',   selection: 'ul'                                   },
                // { type: 'tag',   selection: 'ol'                                   },
            ],
            avoidInjection: {
                before: [
                    { type: 'class', selection: 'an-injection-repeatable-avoid-before' },
                    { type: 'class', selection: 'an-injected'                          },
                    { type: 'class', selection: 'an-zone'                              },
                    { type: 'id',    selection: 'article-limit-drawer'                 },
                    { type: 'id',    selection: 'article-directory-sidenav'            },
                    { type: 'class', selection: 'light-wide-jump-links-positioner'     },
                    { type: 'class', selection: 'js-hidden-by-overlay'                 },

                    // { type: 'class', selection: 'adsninja'  },
                    // { type: 'id',    selection: 'adsninja'  },
                    // { type: 'query', selection: '.adsninja' },
                    // { type: 'tag',   selection: 'adsninja'  },

                    // // FX.
                    // { type: 'id',    selection: 'infobox'                              },
                    // { type: 'class', selection: 'tabtitle'                             },
                ],
                inside: [
                    { type: 'class', selection: 'an-injection-repeatable-avoid-inside' },
                    // { type: 'class', selection: 'an-injected'                          }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'an-zone'                              }, // Don't need because of transparent rules.
                    // { type: 'id',    selection: 'article-limit-drawer'                 }, // Don't need because of transparent rules.
                    // { type: 'id',    selection: 'infobox'                              },
                    // { type: 'class', selection: 'light-wide-jump-links-positioner'     }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'js-hidden-by-overlay'                 }, // Don't need because of transparent rules.
                    // { type: 'tag',   selection: 'header'                               },
                    // { type: 'tag',   selection: 'dialog'                               },

                    // Not needed due to transparency.
                    // { type: 'tag',   selection: 'blockquote'                           },
                    // { type: 'tag',   selection: 'h1'                                   },
                    // { type: 'tag',   selection: 'h2'                                   },
                    // { type: 'tag',   selection: 'h3'                                   },
                    // { type: 'tag',   selection: 'h4'                                   },
                    // { type: 'tag',   selection: 'h5'                                   },
                    // { type: 'tag',   selection: 'h6'                                   },
                    // { type: 'tag',   selection: 'p'                                    },
                    // { type: 'tag',   selection: 'hr'                                   },
                    // { type: 'tag',   selection: 'header'                               },
                    // { type: 'tag',   selection: 'pre'                                  },

                    // For now.
                    // { type: 'tag',   selection: 'table'                                },
                    // { type: 'tag',   selection: 'ul'                                   },
                    // { type: 'tag',   selection: 'ol'                                   },
                    
                    // { type: 'class', selection: 'w-article-limit'                      }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'emaki-custom-block'                   }, // Don't need because of transparent rules (section).
                    // { type: 'class', selection: 'emaki-custom'                         }, // Not needed since we have emaki-custom-block.
                    // { type: 'class', selection: 'body-img'                             }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'valnet-gallery'                       }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'article-jumplink'                     }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'responsive-img'                       }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'display-card'                         }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'w-rich'                               }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'article-table-contents'               }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'dev-stories'                          }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'article-pin-tag'                      }, // Don't need because of transparent rules (section).
                    // { type: 'class', selection: 'table-container'                      }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'display-card-with-links'              },
                    // { type: 'class', selection: 'w-table-content'                      }, // For now.
                    // { type: 'class', selection: 'w-review-item'                        }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'w-article-info-table'                 }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'w-collection-item'                    }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'affiliate-sponsored'                  }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'w-display-card-list'                  }, // For now.
                    // { type: 'id',    selection: 'article-directory-sidenav'            }, // Don't need because of transparent rules.
                    // { type: 'class', selection: 'article-series-top-container'         }, // Old?
                    // { type: 'class', selection: 'article-alert'                        }, // Old?

                    // { type: 'tag',   selection: 'nav'                                  },
                    // { type: 'class', selection: 'article-directory-sidenav'            },
                    // { type: 'query', selection: 'nav.article-directory-sidenav'        },
                    // { type: 'query', selection: '.w-content-full.w-collection-item'    },
                    // { type: 'class', selection: 'key-points'                           },
                    // { type: 'query', selection: '.emaki-custom.key-points'             },
                    // { type: 'class', selection: 'wiki_table'                           },
                    // { type: 'query', selection: 'table.wiki_table'                     },
                    // { type: 'query', selection: '.w-rich.w-justWatch'                  },

                    // // FX.
                    // { type: 'id',    selection: 'infobox'                              },
                    // { type: 'class', selection: 'btn-group'                            },
                    // { type: 'class', selection: 'tabtitle'                             },
                    // { type: 'class', selection: 'hpwidget'                             },
                    // // { type: 'query', selection: '[class^=col-sm-]'                     },

                    // // Forms.
                    // { type: 'class', selection: 'block--category'                      },
                    // { type: 'class', selection: 'structItem--thread'                   },
                    // { type: 'class', selection: 'message--post'                        },
                ],
                after: [
                    { type: 'class', selection: 'an-injection-repeatable-avoid-after' },
                    { type: 'class', selection: 'an-injected'                         },
                    { type: 'class', selection: 'an-zone'                             },
                    { type: 'tag',   selection: 'h1'                                  },
                    { type: 'tag',   selection: 'h2'                                  },
                    { type: 'tag',   selection: 'h3'                                  },
                    { type: 'tag',   selection: 'h4'                                  },
                    { type: 'tag',   selection: 'h5'                                  },
                    { type: 'tag',   selection: 'h6'                                  },
                    { type: 'tag',   selection: 'br'                                  },
                    { type: 'tag',   selection: 'hr'                                  },
                    { type: 'tag',   selection: 'header'                              },
                    { type: 'tag',   selection: 'footer'                              },
                    { type: 'id',    selection: 'article-limit-drawer'                },
                    { type: 'id',    selection: 'article-directory-sidenav'           },
                    { type: 'class', selection: 'light-wide-jump-links-positioner'    },
                    { type: 'class', selection: 'js-hidden-by-overlay'                },
                    { type: 'tag',   selection: 'script'                              },
                    { type: 'tag',   selection: 'style'                               },
                    { type: 'tag',   selection: 'dialog'                              },

                    // // FX.
                    // { type: 'id',    selection: 'infobox'                             },
                    // { type: 'id',    selection: 'palerts'                             },
                    // { type: 'class', selection: 'tabtitle'                            },
                    // { type: 'class', selection: 'btn-group'                           },
                    // { type: 'class', selection: 'col-sm'                              },
                ],
            },
        };

        if(window.adsNinjaHeaderBiddingManager.getBrandName() === 'FX'){

            repeatableRules.avoidInjection.before.push({ type: 'query', selection: '#infobox' });
            repeatableRules.avoidInjection.before.push({ type: 'query', selection: '.tabtitle' });

            repeatableRules.avoidInjection.inside.push({ type: 'query', selection: '#infobox' });
            repeatableRules.avoidInjection.inside.push({ type: 'query', selection: '.btn-group' });
            repeatableRules.avoidInjection.inside.push({ type: 'query', selection: '.tabtitle' });
            repeatableRules.avoidInjection.inside.push({ type: 'query', selection: '.hpwidget' });

            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '#infobox' });
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '#palerts' });
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '.tabtitle' });
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '.btn-group' });
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '.col-sm' });
        }
        else if(window.adsNinjaHeaderBiddingManager.isForum()){

            repeatableRules.avoidInjection.before.push({ type: 'query', selection: '.w-sensa-widget' });
            repeatableRules.avoidInjection.inside.push({ type: 'query', selection: '.w-sensa-widget' });
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '.w-sensa-widget' });
        }

        var target = null;

        if('density' === repeatableSettings.type){

            try{

                var mainContentSelector = (repeatableSettings.contentSelector && repeatableSettings.contentSelector.selector) ? repeatableSettings.contentSelector.selector : null;

                if(!mainContentSelector){

                    this.__logger.error(`Unable to find main content selector for zone.`, {
                        zone: zone,
                    });

                    continue;
                }

                var mainContent = document.querySelectorAll(mainContentSelector);

                if(!mainContent || mainContent.length === 0 || mainContent.length > 1){

                    this.__logger.error(`Unable to find main content for zone.`, {
                        zone: zone,
                        mainContentSelector: mainContentSelector,
                    });

                    continue;
                }

                target = mainContent[0];
            }
            catch(error){

                this.__logger.error(`Unable to find main content for zone.`, {
                    zone: zone,
                });
                this.__logger.error(error);

                continue;
            }           

            // TODO: Make common location for this.
            // TODO: Dedupe arrays.
            repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: '#article-waypoint' });
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: '#article-waypoint' }); // Don't need because of transparent rules.
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '#article-waypoint' });

            repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: '.article-options' }); // For lists.
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: '.article-options' }); // Don't need because of transparent rules.
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '.article-options' });

            repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: '#single-image-modal' });
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: '#single-image-modal' }); // Don't need because of transparent rules.
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '#single-image-modal' });

            repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: '.article-header-bg' });
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: '.article-header-bg' }); // Don't need because of transparent rules.
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '.article-header-bg' });

            repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: '.w-sensa-widget' });
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: '.w-sensa-widget' }); // Don't need because of transparent rules.
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '.w-sensa-widget' });

            repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: '.article-footer-bg' });
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: '.article-footer-bg' }); // Don't need because of transparent rules.
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: '.article-footer-bg' });

            // repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: 'header' });
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: 'header' });
            // repeatableRules.avoidInjection.after.unshift({ type: 'query', selection: 'header' });

            // repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: 'footer' });
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: 'footer' });
            // repeatableRules.avoidInjection.after.unshift({ type: 'query', selection: 'footer' });

            // repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: 'aside' });
            // repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: 'aside' });
            // repeatableRules.avoidInjection.after.unshift({ type: 'query', selection: 'aside' });

            repeatableRules.avoidInjection.before.push({ type: 'query', selection: mainContentSelector });
            repeatableRules.avoidInjection.after.push({ type: 'query', selection: mainContentSelector });
            repeatableRules.transparent.unshift({ type: 'query', selection: mainContentSelector });
            
            repeatableSettings.elementsToIgnore = repeatableSettings.elementsToIgnore || [];

            for(var i = 0; i < repeatableSettings.elementsToIgnore.length; i++){

                var elementToIgnore = repeatableSettings.elementsToIgnore[i];
                var selector        = elementToIgnore.selector;
            
                if(!selector || typeof selector !== 'string'){

                    this.__logger.error('Element to ignore has no selector.', {
                        elementToIgnore,
                    });

                    continue;
                }

                if(elementToIgnore.avoidInjectionAfter){

                    repeatableRules.avoidInjection.after.unshift({ type: 'query', selection: selector });
                }

                if(elementToIgnore.avoidInjectionBefore){

                    repeatableRules.avoidInjection.before.unshift({ type: 'query', selection: selector });
                }

                if(elementToIgnore.avoidInjectionIn){

                    repeatableRules.avoidInjection.inside.unshift({ type: 'query', selection: selector });
                }
            }
        }
        else{

            // First zone is always injected into the main conent. I think.
            if(!zone.isCopy() || !data.hasOwnProperty('injectionConfig')){

                return;
            }

            var injectionConfig     = data.injectionConfig;
            var zoneInjectionConfig = null;

            for(var x in injectionConfig.zones){
                
                var currentZoneInjectionConfig = injectionConfig.zones[x];

                if(currentZoneInjectionConfig.hasOwnProperty('name') && currentZoneInjectionConfig.name === zone.getName()){

                    zoneInjectionConfig = currentZoneInjectionConfig;

                    break;
                }
            }

            if(!zoneInjectionConfig.container || !zoneInjectionConfig.container.type || !zoneInjectionConfig.container.identifier){

                this.__logger.error(`Unable to find injection config for zone: ${zone.getName()}.`);

                continue;
            }

            try{
                switch(zoneInjectionConfig.container.type){

                    case 'id':

                        target = document.getElementById(zoneInjectionConfig.container.identifier);

                        break;

                    case 'class':

                        target = document.getElementsByClassName(zoneInjectionConfig.container.identifier)[0];

                        break;

                    case 'query':

                        target = document.querySelector(zoneInjectionConfig.container.identifier);

                        break;

                    case 'tag':

                        target = document.getElementsByTagName(zoneInjectionConfig.container.identifier)[0];

                        break;
                }
            }
            catch(error){

                this.__logger.error(`Unable to find injection target for zone.`, {
                    zone: zone,
                });
                this.__logger.error(error);

                continue;
            }

            repeatableRules.avoidInjection.after.push({ type: zoneInjectionConfig.container.type, selection: zoneInjectionConfig.container.identifier });
        }
        
        if(!target){

            this.__logger.error(`Unable to find injection target for zone: ${zone.getName()}.`);

            continue;
        }

        try{

            this.monetizeContent(
                target, 
                zone.zoneInfo, 
                repeatableSettings.type, 
                {
                    repeatableSettings: repeatableSettings,
                    repeatableRules: repeatableRules,
                },
                isPageLoad
            );
        }
        catch(error){

            this.__logger.error(`Unable to inject zone.`, {
                zone: zone,
            });
            this.__logger.error(error);
        }
    }
};

//
// Inject repeatble ads.
ANInjector.prototype.monetizeDynamicContent = function(elementId, zoneInfo, action = 'init', additionalDetails = {}, content = ''){ // TODO: Change to accept the target element.

    if(!action 
        || ('append' !== action && 'replace' !== action && 'init' !== action) 
        || !elementId 
        || !zoneInfo 
        || !zoneInfo.hasOwnProperty('name') 
        || !zoneInfo.hasOwnProperty('groupName')
    ){

        throw new Error(`Invalid action, elementId, or zoneInfo: ${action}, ${elementId}, ${JSON.stringify(zoneInfo)}.`);
    }

    var self = this;

    // Check if element exists.
    var element = document.getElementById(elementId);

    if(!element){

        throw new Error(`Unable to find element with ID: ${elementId}.`);
    }

    // Find base zone.
    var baseZone = this.__zoneDelegate.findBaseZone(zoneInfo.name, zoneInfo.groupName);

    if(!baseZone){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find base zone.');
    }

    // Get repeatable settings.
    var rule = baseZone.getRepeatableSettings();

    if(!rule){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find repeatable rule.');
    }

    // Do something with content.
    switch(action){

        case 'init':

            // Inject ads.
            this.__injectRepeatbaleAdsForEveryEntry(element, baseZone, rule, additionalDetails);

            break;

        case 'append':

            // TODO: If append make sure content is not empty. Otherwise, it may be an init.

            // TODO: Add to element.

            // TODO: Inject ads.

            break;

        case 'replace':

            // Clear ads.
            this.__clearAds(element);

            // Clear element.
            element.textContent = '';

            // Add to element.
            element.innerHTML = content;

            // Inject ads.
            this.__injectRepeatbaleAdsForEveryEntry(element, baseZone, rule, additionalDetails);

            break;
    }
};

//
// Inject repeatble ads.
ANInjector.prototype.monetizeEveryEntry = function(target, zoneInfo, addintionalDetails = {}){ // TODO: Change to accept the target element.

    if(!target || !(target instanceof HTMLElement)){

        throw new Error(`Invalid target, expected an element.`);
    }
    else if(!zoneInfo || typeof zoneInfo !== 'object' || !zoneInfo.hasOwnProperty('name') || !zoneInfo.hasOwnProperty('groupName')){

        throw new Error(`Invalid zoneInfo: ${JSON.stringify(zoneInfo)}.`);
    }
    else if(!addintionalDetails || typeof addintionalDetails !== 'object'){

        throw new Error(`Invalid addintionalDetails: ${JSON.stringify(addintionalDetails)}.`);
    }

    // Find base zone.
    var baseZone = this.__zoneDelegate.findBaseZone(zoneInfo.name, zoneInfo.groupName);

    if(!baseZone){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find base zone.');
    }

    // Get repeatable settings.
    var rule = (addintionalDetails && typeof addintionalDetails === 'object' && addintionalDetails.hasOwnProperty('rule')) ? addintionalDetails.rule : baseZone.getRepeatableSettings();

    if(!rule){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find repeatable rule.');
    }

    // // TODO: Support indirect children.
    // var elements = target.children;

    // for(var element of elements){
        
    //     if(element.classList.contains('an-injected') || element.classList.contains('an-ignore')){

    //         continue;
    //     }

    //     if(element.matches(rule.elementSelector)){

    //         // Inject ads.
    //         this.__injectRepeatbaleAdsForEveryEntry(element, baseZone, rule, addintionalDetails);
    //     }
    // }

    // Inject ads.
    this.__injectRepeatbaleAdsForEveryEntryNew(target, baseZone, rule, addintionalDetails);
};

//
// Monetize a table.
ANInjector.prototype.monetizeTable = function(target, zoneInfo, additionalDetails = {}){

    if(!target || !(target instanceof HTMLElement) || !target.tagName.toLowerCase() === 'table'){

        throw new Error(`Invalid target, expected a table.`);
    }
    else if(!zoneInfo || !zoneInfo.hasOwnProperty('name') || !zoneInfo.hasOwnProperty('groupName')){

        throw new Error(`Invalid zoneInfo: ${JSON.stringify(zoneInfo)}.`);
    }

    // Find base zone.
    var baseZone = this.__zoneDelegate.findBaseZone(zoneInfo.name, zoneInfo.groupName);

    if(!baseZone){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find base zone.');
    }

    // Inject ads.
    this.__injectAdsForTable(target, baseZone, additionalDetails);
};

//
// Monitize video.
ANInjector.prototype.monetizeVideo = function(targetSelector, zoneInfo, settings){ // TODO: Change to accept the target element.

    if(!targetSelector 
        || !zoneInfo 
        || !zoneInfo.hasOwnProperty('name') 
        || !zoneInfo.hasOwnProperty('groupName')
        || !settings
    ){

        throw new Error(`Invalid targetSelector, zoneInfo, or settings: ${targetSelector}, ${JSON.stringify(zoneInfo)}, ${JSON.stringify(settings)}.`);
    }
        
    // Find target element.
    var targetElement = document.querySelector(targetSelector);

    if(!targetElement){

        throw new Error(`Unable to find element with selector: ${targetSelector}.`);
    }

    // Get base zone.
    var baseZone = this.__zoneDelegate.findBaseZone(zoneInfo.name, zoneInfo.groupName);

    if(!baseZone){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find base zone.');
    }

    // Add zone to page.
    if(!this.__numberOfInjectedZones.hasOwnProperty(baseZone.zoneInfo.getKey())){

        this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()] = 0;
    }

    var zoneIndex = ++this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()];

    // Create new zone.
    var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(targetElement, 'afterbegin', baseZone, zoneIndex);

    // Init video.
    settings.elementId = newZone.getOriginalUnitElementId();

    if(this.__videoLibrary){
    
        if(settings.hasOwnProperty('trackingId') && settings.trackingId){

            window.adsNinjaHeaderBiddingManager.addToEventTrackingDictionary(settings.elementId, settings.trackingId);
        }

        // HACK: Add to video player settings.
        // TODO: Move this elsewhere.
        window.adsNinjaHeaderBiddingManager.addToVideoPlayerSettings(settings.elementId, settings);

        // TODO: Timing issue with IMA library.
        this.__videoLibrary.configureVideoPlayer(settings);
    }
    else{

        throw new Error('Unable to init video. Video library not configured.');
    }
};

//
// Monitize a list.
ANInjector.prototype.monetizeList = function(target, zoneInfo, additionalDetails = {}){
  
    if(!target || !(target instanceof HTMLElement) || (target.tagName.toLowerCase() !== 'ul' && target.tagName.toLowerCase() !== 'ol')){

        throw new Error(`Invalid target, expected a list.`);
    }
    else if(!zoneInfo || !zoneInfo.hasOwnProperty('name') || !zoneInfo.hasOwnProperty('groupName')){

        throw new Error(`Invalid zoneInfo: ${JSON.stringify(zoneInfo)}.`);
    }

    // Find base zone.
    var baseZone = this.__zoneDelegate.findBaseZone(zoneInfo.name, zoneInfo.groupName);

    if(!baseZone){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find base zone.');
    }

    // Inject ads.
    this.__injectAdsForList(target, baseZone, additionalDetails);
};

//
// Monitize a rail.
ANInjector.prototype.monetizeRail = function(target, zoneInfo, additionalDetails = {}){

    if(!zoneInfo || !zoneInfo.hasOwnProperty('name') || !zoneInfo.hasOwnProperty('groupName')){

        throw new Error(`Invalid zoneInfo: ${JSON.stringify(zoneInfo)}.`);
    }

    // Find base zone.
    var baseZone = this.__zoneDelegate.findBaseZone(zoneInfo.name, zoneInfo.groupName);

    if(!baseZone){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find base zone.');
    }

    // Inject ads.
    this.__injectAdsForRail(target, baseZone, additionalDetails);
};

//
// Inject repeatble ads.
ANInjector.prototype.__clearAds = function(elementToClearAdsFrom){

    if(!elementToClearAdsFrom){

        throw new Error(`Unable to find element: ${elementToClearAdsFrom}.`);
    }

    var zones = elementToClearAdsFrom.getElementsByClassName('an-zone');

    for(var i = 0; i < zones.length; i++){

        var zone = zones[i];

        // Find refresh container.
        var refreshContainers = zone.getElementsByClassName('dynamically-injected-refresh-ad-zone');

        var refreshContainer = null;
        var adElementId      = null;
        var refreshingAdZone = null;

        if(!refreshContainers || refreshContainers.length === 0){   

            this.__logger.warn('Unable to stop refresh of injected ad. Cannot find dynamically injected refresh container.', {
                elementToClearAdsFrom: elementToClearAdsFrom,
                zone: zone,
            });
        }
        else{

            refreshContainer = refreshContainers[0];
            adElementId      = (refreshContainer) ? refreshContainer.getAttribute('data-current-ad-element-id') : null;
        }

        if(!adElementId){

            this.__logger.warn('Unable to stop refresh of injected ad. Cannot find adElementId.', {
                elementToClearAdsFrom: elementToClearAdsFrom,
                zone: zone,
                refreshContainer: refreshContainers[0],
                adElementId: adElementId,
            });  
        }
        else{

            refreshingAdZone = window.adsNinjaHeaderBiddingManager.refreshingAdZones[adElementId];
        }

        // Stop refresh.        
        if(refreshingAdZone){

            // Set attributes.
            refreshingAdZone.setNoRefreshingAllowed();

            // Disable pixel refresher.
            refreshingAdZone.disablePixelRefresher();   

            // Remove scroll timer refresher.
            // This should always be removed and added back when needed.
            refreshingAdZone.removeScrollTimerRefresher(); 

            // Cancel all timeouts and intervals.
            window.adsNinjaHeaderBiddingManager.__clearRefreshTimeouts(adElementId);
            window.adsNinjaHeaderBiddingManager.__clearRefreshIntervals(adElementId);
        }
        else{

            this.__logger.warn('Unable to stop refresh of injected ad. Cannot find refreshingAdZone.', {
                elementToClearAdsFrom: elementToClearAdsFrom,
                zone: zone,
                refreshContainer: refreshContainers[0],
                adElementId: adElementId,
            });
        }

        zone.parentNode.removeChild(zone);
    }
};

//
// Inject repeatble ads for every entry.
ANInjector.prototype.__injectRepeatbaleAdsForEveryEntry = function(elementOfIntrest, baseZone, rule, additionalDetails){
            
    var repeatablePlacementIndex        = -1;
    var placement                       = (rule.placement == 'before') ? 'beforebegin' : 'afterend';
    var numPlacementsSinceLastInjection = 0;

    if(rule.htmlTag.toLowerCase() === "image block"){

        rule.htmlTag = "img";
    }

    var elements      = elementOfIntrest.querySelectorAll(':scope > ' + rule.htmlTag.replace("<", "").replace(">", "")); // TODO: Test.
    var every         = 1; 
    var adsForAuction = [];
    var startingPoint = rule.startingPoint || 1;
    var zonePlacement = 0;

    if(!elements || elements.length === 0){

        return false;
    }

    for(var i = 0; i < elements.length; i++){

        var element = elements[i];

        if(element.classList.contains('an-injected') || element.classList.contains('an-ignore')){

            continue;
        }

        // Rules for ignoreing specific content.
        if(additionalDetails && additionalDetails.hasOwnProperty('countAndIgnore')){
            
            var toContinue = false;
            var values     = Object.values(additionalDetails.countAndIgnore);

            for(var j = 0; j < values.length; j++){

                var entry = values[j];

                if(element.classList.contains(entry)){

                    numPlacementsSinceLastInjection += 1;
                    repeatablePlacementIndex        += 1;
                    toContinue                      = true;
                    
                    break;
                }
            }

            if(toContinue){

                continue;
            }
        }

        if(additionalDetails && additionalDetails.hasOwnProperty('ignore')){
            
            var toContinue = false;
            var values     = Object.values(additionalDetails.ignore);

            for(var j = 0; j < values.length; j++){

                var entry = values[j];

                if(element.classList.contains(entry)){

                    toContinue = true;
                    
                    break;
                }
            }

            if(toContinue){

                continue;
            }
        }

        numPlacementsSinceLastInjection += 1;
        repeatablePlacementIndex        += 1;

        if(startingPoint > repeatablePlacementIndex){

            continue;
        }

        if(rule.hasOwnProperty('degradationStartingPoint') && null !== rule.degradationStartingPoint && repeatablePlacementIndex >= rule.degradationStartingPoint){

            every = rule.degradationEntityCount;
        }

        if (rule.hasOwnProperty('stopAds') && null !== rule.stopAds && zonePlacement >= (rule.stopAds + 1) ) {
            this.__logger.debug('Ad injection stopped.', {
                element: element,
                zone: baseZone,
                rule: rule
                
            });
            break;
        }



        if(!this.__numberOfInjectedZones.hasOwnProperty(baseZone.zoneInfo.getKey())){

            this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()] = 0;
        }

        if(numPlacementsSinceLastInjection >= every){
        
            numPlacementsSinceLastInjection = 0;

            var zoneIndex = ++this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()];

            zonePlacement += 1;

            if (rule.hasOwnProperty('skipEvery') && null !== rule.skipEvery && zonePlacement % (rule.skipEvery+1) === 0) {
                this.__logger.debug('Ad injection skipped.', {
                    element: element,
                    zone: baseZone,
                    rule: rule
                    
                });
                continue;
            } 

            // Create new zone.
            var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(element, placement, baseZone, zoneIndex, function(content){ // TODO; Fix.

                return `<li class="an-injected">${content}</li>`;  
            });

            // Add ad to auction.
            adsForAuction.push(newZone.getOriginalUnit());
        }
    }

    elementOfIntrest.insertAdjacentHTML('beforebegin', `<!-- AN - Secondary Injection Start -->`);
    elementOfIntrest.insertAdjacentHTML('afterend', `<!-- AN - Secondary Injection End -->`);

    // Do auction.
    this.__createAndStartAuction(adsForAuction, false, `EER_${elementOfIntrest.id || ''}_${Date.now()}`);

    return true;
};

//
// Inject repeatble ads for every entry.
ANInjector.prototype.__injectRepeatbaleAdsForEveryEntryNew = function(elementOfIntrest, baseZone, rule, addintionalDetails){
            
    if(rule.htmlTag.toLowerCase() === "image block"){

        rule.htmlTag = "img";
    }

    var elements = target.children;

    // TODO: Support indirect children.
    // var elements = target.children;

    // for(var element of elements){
        
    //     if(element.classList.contains('an-injected') || element.classList.contains('an-ignore')){

    //         continue;
    //     }

    //     if(element.matches(rule.elementSelector)){

    //         // Inject ads.
    //         this.__injectRepeatbaleAdsForEveryEntry(element, baseZone, rule, addintionalDetails);
    //     }
    // }

    if(!elements || elements.length === 0){

        return false;
    }

    var repeatablePlacementIndex        = -1;
    var placement                       = (rule.placement == 'before') ? 'beforebegin' : 'afterend';
    var numPlacementsSinceLastInjection = 0;
    var every                           = 1; 
    var adsForAuction                   = [];
    var startingPoint                   = rule.startingPoint || 1;

    for(var element of elements){

        if(element.classList.contains('an-injected') || element.classList.contains('an-ignore') || !element.matches(rule.elementSelector)){

            continue;
        }

        // // Rules for ignoreing specific content.
        // if(addintionalDetails && addintionalDetails.hasOwnProperty('countAndIgnore')){
            
        //     var toContinue = false;
        //     var values     = Object.values(addintionalDetails.countAndIgnore);

        //     for(var j = 0; j < values.length; j++){

        //         var entry = values[j];

        //         if(element.classList.contains(entry)){

        //             numPlacementsSinceLastInjection += 1;
        //             repeatablePlacementIndex        += 1;
        //             toContinue                      = true;
                    
        //             break;
        //         }
        //     }

        //     if(toContinue){

        //         continue;
        //     }
        // }

        // if(addintionalDetails && addintionalDetails.hasOwnProperty('ignore')){
            
        //     var toContinue = false;
        //     var values     = Object.values(addintionalDetails.ignore);

        //     for(var j = 0; j < values.length; j++){

        //         var entry = values[j];

        //         if(element.classList.contains(entry)){

        //             toContinue = true;
                    
        //             break;
        //         }
        //     }

        //     if(toContinue){

        //         continue;
        //     }
        // }

        numPlacementsSinceLastInjection += 1;
        repeatablePlacementIndex        += 1;

        if(startingPoint > repeatablePlacementIndex){

            continue;
        }

        if(rule.hasOwnProperty('degradationStartingPoint') && null !== rule.degradationStartingPoint && repeatablePlacementIndex >= rule.degradationStartingPoint){

            every = rule.degradationEntityCount;
        }

        if(!this.__numberOfInjectedZones.hasOwnProperty(baseZone.zoneInfo.getKey())){

            this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()] = 0;
        }

        if(numPlacementsSinceLastInjection >= every){
        
            numPlacementsSinceLastInjection = 0;

            var zoneIndex = ++this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()];

            // Create new zone.
            var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(element, placement, baseZone, zoneIndex, function(content){ // TODO; Fix.

                return `<div class="an-injected">${content}</div>`;  
            });

            // Add ad to auction.
            adsForAuction.push(newZone.getOriginalUnit());
        }
    }

    elementOfIntrest.insertAdjacentHTML('beforebegin', `<!-- AN - Secondary Injection Start -->`);
    elementOfIntrest.insertAdjacentHTML('afterend', `<!-- AN - Secondary Injection End -->`);

    // Do auction.
    this.__createAndStartAuction(adsForAuction, false, `EER_${elementOfIntrest.id || ''}_${Date.now()}`);

    return true;
};

//
// Inject repeatble ads for tables.
ANInjector.prototype.__injectAdsForTable = function(elementOfIntrest, baseZone, additionalDetails){
        
    if(!elementOfIntrest 
        || elementOfIntrest.classList.contains('an-injected') 
        || elementOfIntrest.classList.contains('an-ignore')
        || !baseZone 
        || typeof baseZone !== 'object' 
        || Object.keys(baseZone).length === 0
    ){

        return false;
    }

    if(additionalDetails && additionalDetails.hasOwnProperty('ignore')){
            
        var toIgnore = Object.values(additionalDetails.ignore);

        for(var j = 0; j < toIgnore.length; j++){

            var entry = toIgnore[j];

            //check if element have a ignored class
            if(elementOfIntrest.classList.contains(entry)){
                return false;
            }
            //check if element have a ignored id
            if(elementOfIntrest.id === entry){
                return false;
            }
        }
    }

    // Count containers.
    var injectableContainerElements         = elementOfIntrest.querySelectorAll(':scope > thead, :scope > tbody, :scope > tfoot');
    var numberOfInjectableContainerElements = injectableContainerElements.length;

    if(numberOfInjectableContainerElements === 0){

        return false;
    }

    // TODO: Remove this in favour of configs.
    if(window.adsNinjaHeaderBiddingManager && 'FextraLife' === window.adsNinjaHeaderBiddingManager.getBrandName()){
        
        this.SECONDARY_INJECTION_TABLE_MIN_ROWS    = 8; // TODO: Make this configurable.
        this.SECONDARY_INJECTION_TABLE_BUFFER_ROWS = 4;
    }

    // Count rows.
    var totalRowCount = 0;
    var rowElements   = [];

    for(var i = 0; i < injectableContainerElements.length; i++){

        var tableRowElements = injectableContainerElements[i].querySelectorAll(':scope > tr');
        totalRowCount        += tableRowElements.length;

        rowElements = [...rowElements, ...tableRowElements];
    }

    // Skip table with too few rows.
    if(totalRowCount < this.SECONDARY_INJECTION_TABLE_MIN_ROWS){

        return false;
    }

    var rowSpanTracking              = [];
    var headerColumnSpan             = 0;
    var canInjectAd                  = false;
    var numberOfAdsInjected          = 0;   
    var isHeader                     = false;  
    var injectionTotalFullRowCount   = 0;
    var runningTotalFullRowCount     = 0;
    var runningTotalEmptyRowCount    = 0;
    var possibleNumberOfAdInjections = Math.max(Math.floor(totalRowCount / this.SECONDARY_INJECTION_TABLE_BUFFER_ROWS), 1);
    var adsForAuction                = [];

    // Loop through all rows.
    for(var i = 0; i < rowElements.length; i++){
    
        var rowElement     = rowElements[i];
        var columnElements = rowElement.querySelectorAll(':scope > th, :scope > td');

        if(columnElements.length === 0){

            runningTotalEmptyRowCount += 1;

            continue;
        }

        runningTotalFullRowCount   += 1; // TODO: Fix, check rowspan.
        injectionTotalFullRowCount += 1;
        canInjectAd                = false;

        if((totalRowCount - runningTotalFullRowCount - runningTotalEmptyRowCount) >= this.SECONDARY_INJECTION_TABLE_BUFFER_ROWS 
            && injectionTotalFullRowCount >= this.SECONDARY_INJECTION_TABLE_BUFFER_ROWS
        ){

            canInjectAd = true;
        }

        // Reduce all entries in tracking array by 1.
        rowSpanTracking = rowSpanTracking.map(function(item){ 
            
            return item - 1;
        });
        rowSpanTracking = rowSpanTracking.filter(function(item){ 
            
            return item > 0;
        });

        var columnSpanCount = 0;

        for(var j = 0; j < columnElements.length; j++){

            var columnElement = columnElements[j];
            columnSpanCount   += Number(columnElement.getAttribute('colspan') || 1);
            var rowSpanCount  = Number(columnElement.getAttribute('rowspan') || 1);

            if(rowSpanCount > 1){

                rowSpanTracking.push(rowSpanCount);
            }
        }

        headerColumnSpan = (0 === i) ? columnSpanCount : headerColumnSpan;

        if(canInjectAd 
            && (!rowSpanTracking || 0 === rowSpanTracking.length || 0 === Math.max(...rowSpanTracking)) 
            && columnSpanCount >= headerColumnSpan
        ){

            // Inject.
            numberOfAdsInjected        += 1;
            injectionTotalFullRowCount = 0;
            canInjectAd                = false;

            if(!this.__numberOfInjectedZones.hasOwnProperty(baseZone.zoneInfo.getKey())){

                this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()] = 0;
            }

            var zoneIndex = ++this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()];

            // Create new zone.
            var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(rowElement, 'afterend', baseZone, zoneIndex, function(content){

                return `<tr class="an-injected"><td colspan=${headerColumnSpan}>${content}</td></tr>`;   
            });

            // Add ad to auction.
            adsForAuction.push(newZone.getOriginalUnit());
        }
    }

    // Debug info.
    var debugInfo = {
        injection: 'secondary',
        numberOfAdsInjected: numberOfAdsInjected,
        totalRowCount: totalRowCount,
        runningTotalFullRowCount: runningTotalFullRowCount,
        runningTotalEmptyRowCount: runningTotalEmptyRowCount,
        possibleNumberOfAdInjections: possibleNumberOfAdInjections,
        headerColumnSpan: headerColumnSpan,
    }; 

    debugInfo = JSON.stringify(debugInfo);

    elementOfIntrest.insertAdjacentHTML('beforebegin', `<!-- AN - Secondary Injection Start -->`);
    elementOfIntrest.insertAdjacentHTML('afterend', `<!-- AN - Secondary Injection End --> \n <!-- Debug data: ${debugInfo} -->`);

    // Do auction.
    this.__createAndStartAuction(adsForAuction, false, `Table_${elementOfIntrest.id || ''}_${Date.now()}`);

    return true;
};

//
// Inject repeatble ads for tables.
ANInjector.prototype.__injectAdsForList = function(elementOfIntrest, baseZone, additionalDetails){

    if(!elementOfIntrest 
        || elementOfIntrest.classList.contains('an-injected')
        || elementOfIntrest.classList.contains('an-ignore')
        || !baseZone 
        || typeof baseZone !== 'object' 
        || Object.keys(baseZone).length === 0
    ){

        return false;
    }

    if(additionalDetails && additionalDetails.hasOwnProperty('ignore')){
            
        var toIgnore = Object.values(additionalDetails.ignore);

        for(var j = 0; j < toIgnore.length; j++){

            var entry = toIgnore[j];

            //check if element have a ignored class
            if(elementOfIntrest.classList.contains(entry)){
                return false;
            }
            //check if element have a ignored id
            if(elementOfIntrest.id === entry){
                return false;
            }
        }
    }

    var currentList                 = elementOfIntrest;
    var listType                    = elementOfIntrest.tagName.toLowerCase();
    var listAttributes              = elementOfIntrest.attributes;
    var listClassName               = elementOfIntrest.className;
    var listStartingPoint           = elementOfIntrest.getAttribute('start') || 1;
    var totalListItemCount          = elementOfIntrest.querySelectorAll(':scope li').length;
    var injectableContainerElements = elementOfIntrest.querySelectorAll(':scope > li');
    var numberOfRootListItems       = injectableContainerElements.length;

    // Skip lists with too few rows.
    if(totalListItemCount < this.SECONDARY_INJECTION_LIST_MIN_ROWS){

        return false;
    }

    var numberOfAdsInjected          = 0;   
    var possibleNumberOfAdInjections = Math.max(Math.floor(totalListItemCount / this.SECONDARY_INJECTION_TABLE_BUFFER_ROWS), 1);
    var runningTotalListItemCount    = 0;
    var injectionListItemCount       = 0;
    var adsForAuction                = [];

    for(var i = 0; i < injectableContainerElements.length; i++){

        var listItem              = injectableContainerElements[i];
        var listItemCount         = listItem.querySelectorAll(':scope li').length;
        runningTotalListItemCount += listItemCount + 1;
        injectionListItemCount    += listItemCount + 1;

        // Check if there's enough list items.
        if((totalListItemCount - runningTotalListItemCount) < this.SECONDARY_INJECTION_LIST_BUFFER_ROWS || injectionListItemCount < this.SECONDARY_INJECTION_LIST_BUFFER_ROWS){ 

            continue;
        }

        // Inject.
        if(!this.__numberOfInjectedZones.hasOwnProperty(baseZone.zoneInfo.getKey())){

            this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()] = 0;
        }

        var zoneIndex = ++this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()];

        // Create a new list below the current one.
        var newList = document.createElement(listType);

        for(var attribute of listAttributes){

            if(!attribute.value || '' === attribute.name.toLowerCase()){

                return;
            }

            newList.setAttribute(attribute.name, attribute.value);
        }

        newList.setAttribute('start', listStartingPoint + i + 1);

        newList.className = listClassName;
        newList.id        = '';

        currentList.insertAdjacentElement('afterend', newList);

        // Create new zone.
        var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(newList, 'beforebegin', baseZone, zoneIndex);

        // Add ad to auction.
        adsForAuction.push(newZone.getOriginalUnit());

        numberOfAdsInjected    += 1;
        injectionListItemCount = 0;

        // Move list items to new list.
        for(var j = i + 1; j < injectableContainerElements.length; j++){

            var listItemToMove = injectableContainerElements[j];

            newList.appendChild(listItemToMove);
        }

        currentList = newList;
    }

    // Debug info.
    var debugInfo = {
        injection: 'secondary',
        totalListItemCount: totalListItemCount,
        numberOfRootListItems: numberOfRootListItems,
        numberOfAdsInjected: numberOfAdsInjected,
        possibleNumberOfAdInjections: possibleNumberOfAdInjections,
    }; 

    debugInfo = JSON.stringify(debugInfo);

    elementOfIntrest.insertAdjacentHTML('beforebegin', `<!-- AN - Secondary Injection Start -->`);
    currentList.insertAdjacentHTML('afterend', `<!-- AN - Secondary Injection End --> \n <!-- Debug data: ${debugInfo} -->`);

    // Do auction.
    this.__createAndStartAuction(adsForAuction, false, `List_${elementOfIntrest.id || ''}_${Date.now()}`);

    return true;
};

//
// Create and start an auction.
ANInjector.prototype.__createAndStartAuction = function(adsForAuction, waitTillAdsAreInview = false, auctionId = null){
    
    if(!adsForAuction || adsForAuction.length === 0){

        return false;   
    }

    if(waitTillAdsAreInview){

        window.adsNinjaHeaderBiddingManager.auctionManager.waitTillAdsAreInview(adsForAuction);

        return;
    }

    if(!auctionId || '' === auctionId){

        auctionId = `Secondary_${Date.now()}`;
    }

    // Set auction ID for each ad.
    adsForAuction.forEach(function(ad){

        ad.auctionId = auctionId;
    });

    // Run auction.
    var auction = window.adsNinjaHeaderBiddingManager.setupAuctionRepeatable(adsForAuction, auctionId);

    if(!auction){

        this.__logger.debug('No repeatable auction to be held!');

        return false;
    }

    window.adsNinjaHeaderBiddingManager.requestHeaderBids(auction.getId());
    window.adsNinjaHeaderBiddingManager.startFailSafeTimeout(auction.getId());
};

//
// Handles additional injection for a rail.
ANInjector.prototype.recalculateRail = function(target, zoneInfo, additionalDetails){
    
    var self = this;

    setTimeout(function(){

        self.monetizeRail(target, zoneInfo, additionalDetails);
    }, 2000);
};

//
// Inject ads for a continuous block.
// Will try and inject as many ads as possible, while respecting height and spacing constraints.
ANInjector.prototype.__injectAdsForRail = function(elementOfIntrest, baseZone, additionalDetails){

    // Check if we can inject ads for this element.
    if(!this.__validateTarget(elementOfIntrest, baseZone, additionalDetails)){

        return false;
    }

    // Get element ID or create one. Then get or create continuous block.
    var elementOfIntrestId         = elementOfIntrest.id || `an-injector-rail-wrapper-${Date.now()}`;
    elementOfIntrest.id            = elementOfIntrestId;
    var rail                       = this.__rails[elementOfIntrestId] || null;
    var initial                    = false;
    var minimumHeightThreshold     = null;
    var marginTop                  = 0;
    var currentlyUsedHeight        = 0;
    var railItemElementHeight      = null;
    var lastRecordedHeight         = null;
    var zoneIndex                  = 0;
    var usedShortAdForCalculations = false;
    var zone                       = baseZone;
    var backupZone                 = null;
    var usingBackupZone            = false;
    var baseRailItemElementHeight  = this.__getRailItemHeight(baseZone);
    var self                       = this;

    // If the rail element is not tall enough, then we should not add any ads to it.      
    if(additionalDetails && typeof additionalDetails === 'object' && additionalDetails.hasOwnProperty('backupZoneInfo')){

        // Try adding a backup ad to the rail.
        backupZone = this.__zoneDelegate.findBaseZone(additionalDetails.backupZoneInfo.name, additionalDetails.backupZoneInfo.groupName);
    }

    if(!rail){

        elementOfIntrest.insertAdjacentHTML('beforebegin', `<!-- AN - Secondary Injection Start -->`);
        elementOfIntrest.insertAdjacentHTML('afterend', `<!-- AN - Secondary Injection End -->`);

        // Determine what the first rail item element height should be.
        railItemElementHeight  = this.__getRailItemHeight(zone);
        minimumHeightThreshold = railItemElementHeight;

        try{

            // Create new rail.
            rail                             = new ANRail(elementOfIntrest, railItemElementHeight, minimumHeightThreshold, 100, this.__logger);
            this.__rails[elementOfIntrestId] = rail;
            initial                          = true;

            // Monitor rail resize.
            rail.observeResize(function(){

                self.recalculateRail(elementOfIntrest, baseZone.zoneInfo, additionalDetails);
            });
        }
        catch(error){

            this.__logger.error('Failed to initialise rail.', {
                rail: rail,
            });
            this.__logger.error(error);

            return false;
        }
    }
    else{

        // Check lock.
        if(rail.isLocked()){

            return false;
        }
        else{
            
            rail.lock();
        }

        marginTop                  = rail.getMarginTop();
        minimumHeightThreshold     = rail.getMinimumHeightThreshold();
        currentlyUsedHeight        = rail.getCurrentlyUsedHeight();
        railItemElementHeight      = rail.getItemElementHeight();
        railElement                = rail.getElement();
        lastRecordedHeight         = rail.getLastRecordedHeight();
        zoneIndex                  = rail.getItemCount();
        usedShortAdForCalculations = rail.getUsedShortAdForCalculations();

        if(0 === zoneIndex){
            
            initial   = true;
            marginTop = 0;
        }

        if(usedShortAdForCalculations){

            railItemElementHeight  = this.__getRailItemHeight(zone);
            minimumHeightThreshold = railItemElementHeight + marginTop;
        }
    }

    // Get height of rail without padding.
    var railElementComputedStyle = getComputedStyle(railElement);
    var railElementHeight        = railElement.clientHeight; // Height with padding.
    railElementHeight            -= parseFloat(railElementComputedStyle.paddingTop) + parseFloat(railElementComputedStyle.paddingBottom);

    if(!initial && lastRecordedHeight >= railElementHeight){

        return false;
    }
    else if((!initial && (railElementHeight - currentlyUsedHeight) < minimumHeightThreshold) 
        || (initial && railElementHeight <= minimumHeightThreshold)
    ){

        // If the rail element is not tall enough, then we should not add any ads to it. Try adding a backup ad to the rail.
        if(!backupZone){

            this.__logger.warn(`Rail is not tall enough to add items to it. Also unable to find backup zone for rail.`, {
                parentElementId: elementOfIntrestId,
            });

            return false;
        }

        usingBackupZone        = true;
        zone                   = backupZone;
        railItemElementHeight  = this.__getRailItemHeight(zone);
        minimumHeightThreshold = railItemElementHeight + marginTop;

        if((railElementHeight - currentlyUsedHeight) < minimumHeightThreshold){

            return false;
        }

        if(initial){
            
            usedShortAdForCalculations = true;
        
            rail.setUsedShortAdForCalculations(usedShortAdForCalculations);
        }
    }
    
    if(location.hostname.indexOf('fextralife.com') !== -1){

        var testRailElementHeight = railElementHeight - ((2 * baseRailItemElementHeight) + (2 * marginTop));

        if(testRailElementHeight >= baseRailItemElementHeight){

            railElementHeight = testRailElementHeight;
        }
    }
    
    rail.setLastRecordedHeight(railElementHeight);

    if(!railItemElementHeight){

        this.__logger.warn(`Unable to configure rail in element with ID: ${elementOfIntrestId}.`);

        return false;
    }

    var maxItems = rail.getMaxItems();

    if(null !== maxItems && zoneIndex >= maxItems){

        return false;
    }

    var firstInjection = true;
    var adsForAuction  = [];

    // Append ads to rail.
    // Try injecting another ad up until there is no more room for the full height of the ad.
    do{

        if(!initial){

            // Remove extra styling for last rail item.
            var lastItemElement = rail.getLastItemElement();
        
            if(lastItemElement){

                lastItemElement.classList.remove('an-rail-item-last');
            }
        }

        // Create new zone.
        var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(railElement, 'beforeend', zone, zoneIndex, function(content){

            return `<div class="an-rail-item" id="an-rail-item-${zoneIndex}" style="margin-top: ${marginTop}px">${content}</div>`;   
        });

        var originalItem                         = newZone.getOriginalUnit();
        var originalItemZoneRootContainerElement = originalItem.getAdZoneRootContainerElement();
        var railItemElement                      = originalItemZoneRootContainerElement.parentNode;

        if(!railItemElement.classList.contains('an-rail-item')){

            this.__logger.error('Invalid rail item element.', {

                railItemElement: railItemElement,
            });

            return false;
        }

        rail.addItem(railItemElement, newZone);

        // Add ad to auction.
        adsForAuction.push(originalItem);

        if((initial && firstInjection) || (!initial && !usingBackupZone && usedShortAdForCalculations)){

            firstInjection = false;
            marginTop      = rail.getMarginTop();

            // Get real height of first rail item element.
            railItemElementHeight = railItemElement.clientHeight; // Height with padding.
            currentlyUsedHeight   += railItemElementHeight;

            rail.setItemElementHeight(railItemElementHeight);
            rail.setMinimumHeightThreshold(railItemElementHeight + marginTop);

            if(!initial && !usingBackupZone && usedShortAdForCalculations){

                usedShortAdForCalculations = false;

                rail.setUsedShortAdForCalculations(usedShortAdForCalculations);
            }
        }
        else{

            currentlyUsedHeight += (railItemElementHeight + marginTop);
        }

        zoneIndex++;

        if(usingBackupZone){

            break;
        }

        if(null !== maxItems && zoneIndex >= maxItems){

            break;
        }

        // Recalculate rail height without padding.
        railElementComputedStyle = getComputedStyle(railElement);
        railElementHeight        = railElement.clientHeight; // Height with padding.
        railElementHeight        -= parseFloat(railElementComputedStyle.paddingTop) + parseFloat(railElementComputedStyle.paddingBottom);
    }
    while(!usingBackupZone && (currentlyUsedHeight <= (railElementHeight - (railItemElementHeight + marginTop))));

    // Try and inject one more backup zone if the rail is tall enough.
    if(backupZone){

        railItemElementHeight  = this.__getRailItemHeight(backupZone);
        minimumHeightThreshold = railItemElementHeight + marginTop;
    
        if((railElementHeight - currentlyUsedHeight) >= minimumHeightThreshold){
    
            // Create new zone.
            var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(railElement, 'beforeend', backupZone, zoneIndex, function(content){
    
                return `<div class="an-rail-item" id="an-rail-item-${zoneIndex}" style="margin-top: ${marginTop}px">${content}</div>`;   
            });
    
            var originalItem                         = newZone.getOriginalUnit();
            var originalItemZoneRootContainerElement = originalItem.getAdZoneRootContainerElement();
            var railItemElement                      = originalItemZoneRootContainerElement.parentNode;
    
            if(!railItemElement.classList.contains('an-rail-item')){
    
                this.__logger.error('Invalid rail item element.', {
    
                    railItemElement: railItemElement,
                });
            }
    
            rail.addItem(railItemElement, newZone);
    
            // Add ad to auction.
            adsForAuction.push(originalItem);
    
            currentlyUsedHeight += (railItemElementHeight + marginTop);
    
            zoneIndex++;
        }
    }

    rail.setCurrentlyUsedHeight(currentlyUsedHeight);

    var railItemElementLast = rail.getLastItemElement();

    if(railItemElementLast){

        railItemElementLast.classList.add('an-rail-item-last');
    }

    // Add debug comment.
    railElement.insertAdjacentHTML('beforeend', rail.getDebugComment(currentlyUsedHeight));

    rail.setLastRecordedHeight(railElementHeight);

    // Do auction.
    this.__createAndStartAuction(adsForAuction, false, `Rail_${elementOfIntrest.id || ''}_${Date.now()}`);

    // Unlock.
    rail.unlock();

    return true;
};

//
// Validate target.
ANInjector.prototype.__validateTarget = function(elementOfIntrest, baseZone, additionalDetails){

    if(!elementOfIntrest 
        || elementOfIntrest.classList.contains('an-injected') 
        || elementOfIntrest.classList.contains('an-ignore')
        || !baseZone 
        || typeof baseZone !== 'object' 
        || Object.keys(baseZone).length === 0
    ){

        return false;
    }

    // TODO: Look to remove this.
    if(additionalDetails && additionalDetails.hasOwnProperty('ignore')){
            
        var toIgnore = Object.values(additionalDetails.ignore);

        for(var j = 0; j < toIgnore.length; j++){

            var entry = toIgnore[j];

            // Hack: Values are stored as arrays.
            if(Array.isArray(entry)){

                entry = entry[0];
            }

            if(typeof entry !== 'string'){

                continue;
            }

            // Check if element is a tag that should be ignored.
            if(elementOfIntrest.tagName.toLowerCase() === entry.toLowerCase()){

                return false;
            }

            // Check if element has a class that should be ignored.
            if(elementOfIntrest.classList.contains(entry)){

                return false;
            }
            
            // Check if element has an ID that should be ignored.
            if(elementOfIntrest.id === entry){

                return false;
            }
        }
    }

    return true;
};

//
// Get rail item height.
ANInjector.prototype.__getRailItemHeight = function(zone){ 

    var originalItem       = zone.getOriginalUnit();
    var height             = originalItem.height || null;
    height                 = (!height) ? 0 : parseFloat(height);
    var padding            = 32; // TODO: Get padding from CSS.
    padding                = 0;                                  

    return height + padding;
};

/**
 * Monetize content.
 * 
 * @param {HTMLElement} target 
 * @param {ANZoneInfo} zoneInfo 
 * @param {string} type 
 * @param {Object} additionalDetails 
 * @param {boolean} isPageLoad 
 */
ANInjector.prototype.monetizeContent = function(target, zoneInfo, type, additionalDetails = {}, isPageLoad = false){

    var key   = zoneInfo.getKey();
    var first = false;
    var self  = this;

    if(!this.__monetizeContentQueues.hasOwnProperty(key)){

        first                             = true;
        this.__monetizeContentQueues[key] = new ANInjectorQueue([], 10000, this.__logger);
    }

    // To avoid spamming the same zone with multiple injection requests.
    this.__monetizeContentQueues[key].push(function(){

        self.__monetizeContent(target, zoneInfo, type, additionalDetails, isPageLoad, first);
    });
};

/**
 * Monetize content.
 * 
 * @param {HTMLElement} target 
 * @param {ANZoneInfo} zoneInfo 
 * @param {string} type 
 * @param {Object} additionalDetails 
 * @param {boolean} isPageLoad 
 * @param {boolean} first
 */
ANInjector.prototype.__monetizeContent = function(target, zoneInfo, type, additionalDetails = {}, isPageLoad = false, first = false){
  
    if(!zoneInfo || !zoneInfo.hasOwnProperty('name') || !zoneInfo.hasOwnProperty('groupName')){

        throw new Error(`Invalid zoneInfo: ${JSON.stringify(zoneInfo)}.`);
    }
    
    if(!additionalDetails 
        || !additionalDetails.hasOwnProperty('repeatableRules')
        || !additionalDetails.repeatableRules.hasOwnProperty('avoidInjection')
        || !additionalDetails.repeatableRules.avoidInjection.hasOwnProperty('before')
        || !additionalDetails.repeatableRules.avoidInjection.hasOwnProperty('inside')
        || !additionalDetails.repeatableRules.avoidInjection.hasOwnProperty('after')
    ){

        throw new Error(`Invalid additionalDetails: ${JSON.stringify(additionalDetails)}.`);
    }

    // Find base zone.
    var baseZone = this.__zoneDelegate.findBaseZone(zoneInfo.name, zoneInfo.groupName);

    if(!baseZone){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find base zone.');
    }

    // Get repeatable rules.
    var rule = baseZone.getRepeatableSettings();

    if(!rule || typeof rule !== 'object' || Object.keys(rule).length === 0){

        // TODO: Auto handle this case without throwning an error.
        throw new Error('Unable to find repeatable settings.');
    }

    // Always recalculate because elements may have shifted.
    var zoneDistanceHelper = this.__getDistanceHelper(target, baseZone, rule); 
    zoneDistanceHelper.recalculate();

    if('density' === type){

        var densityManager = this.__getDensityManager(target, baseZone);
        densityManager.recalculate();
    }

    // Inject ads.
    var result = this.__injectRepeatbaleAdsForPixelDistance(
        target, 
        baseZone, 
        rule, 
        zoneDistanceHelper, 
        densityManager,
        additionalDetails,
        first
    );

    var adsForAuction = result.adsForAuction;
    var count         = 0;

    if(!isPageLoad){

        // If not page load then we need to handle auction manually.
        this.__createAndStartAuction(adsForAuction, true);
    }
    else{

        // Hack.
        // Set ads to not be frontend injectable with injector.
        // TODO: Later we can do something with the adsForAuction.
        for(var x in adsForAuction){

            var ad = adsForAuction[x];

            if(!ad.__originalAdData || !ad.__originalAdData.hasOwnProperty('zone')){

                continue;
            }

            ad.__originalAdData.zone.isFrontEndInjectable = false;

            if(count < 2){

                ad.onPageLoad = true;
            }

            count++;
        }
    }

    return true;
};

/**
 * Inject repeatable ads for pixel distance.
 * 
 * @param {HTMLElement} target 
 * @param {ANZoneDictionaryItem} baseZone 
 * @param {object} rule 
 * @param {ANInjectorZoneDistanceHelper} zoneDistanceHelper 
 * @param {ANDensityManager} densityManager
 * @param {boolean} first
 * @param {object} additionalDetails 
 * @param {number} currentPixelCount 
 * @param {Array} adsForAuction 
 * @param {HTMLElement} nextTarget 
 * @returns {object}
 */
ANInjector.prototype.__injectRepeatbaleAdsForPixelDistance = function(
    target, 
    baseZone, 
    rule, 
    zoneDistanceHelper, 
    densityManager,
    additionalDetails, 
    first = false,
    currentPixelCount = 0, 
    adsForAuction = [],
    nextTarget = null,
){

    // Check if we can inject ads for this element, including height.
    if(!this.__validateTarget(target, baseZone, additionalDetails) || !target.clientHeight){

        return {
            adsForAuction: adsForAuction,
            currentPixelCount: currentPixelCount,
        };
    }
    
    if(!this.__numberOfInjectedZones.hasOwnProperty(baseZone.zoneInfo.getKey())){

        this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()] = 0;
    }

    // var didInjectAd = false;
    var placement     = 'afterend';
    var pixelDistance = this.__getPixelDistance(
        this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()],
        rule,
        this.__getTopYPosition(target),
        densityManager
    );

    // Check pixel distance.
    if(pixelDistance && target.clientHeight < (pixelDistance - ((densityManager) ? 0 : currentPixelCount))){
        
        return {
            adsForAuction: adsForAuction,
            currentPixelCount: currentPixelCount,
        };
    }

    // Loop through children.
    for(var i = 0; i < target.children.length; i++){

        var child = target.children[i];

        // Skip element if it was just injected.
        if(child.classList.contains('an-injected')){

            continue;
        }

        // Get pixel distance.
        pixelDistance = this.__getPixelDistance(
            this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()],
            rule,
            this.__getTopYPosition(child),
            densityManager
        );

        // Determine if element is allowed and large enough to inject an ad inside of it.
        // Also if this is not the first run then check the location of last injected ad and if this element is higher than it we can skip it.
        if(this.__isElementTransparent(child, additionalDetails.repeatableRules.transparent)
            && pixelDistance
            && child.clientHeight > (pixelDistance - ((densityManager) ? 0 : currentPixelCount))
            && this.__validateRepeatableRules('avoidInjectionInside', child, additionalDetails.repeatableRules.avoidInjection.inside)
            && (first || (!first && zoneDistanceHelper.isElementBelowLastInjectedZone(child)))
        ){

            // var currentNumberOfInjectedZones = adsForAuction.length;

            var result = this.__injectRepeatbaleAdsForPixelDistance(
                child, 
                baseZone, 
                rule, 
                zoneDistanceHelper,
                densityManager,
                additionalDetails, 
                first,
                currentPixelCount, 
                adsForAuction
            );

            adsForAuction     = result.adsForAuction;
            currentPixelCount = result.currentPixelCount;
            // didInjectAd       = (adsForAuction.length > currentNumberOfInjectedZones);
        }
        else{

            currentPixelCount += child.clientHeight;
        }

        // Get pixel distance.
        pixelDistance = this.__getPixelDistance(
            this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()],
            rule,
            this.__getBottomYPosition(child),
            densityManager
        );

        var nextChild = target.children[i + 1];

        // While looping through children, check if we can inject an ad after this element and before the next element. 
        // All while maintaining a minimum spacing between zones.
        if(nextChild
            && pixelDistance
            && (densityManager || (!densityManager && currentPixelCount >= pixelDistance))
            && this.__validateRepeatableRules('avoidInjectionAfter', child, additionalDetails.repeatableRules.avoidInjection.after)
            && this.__validateRepeatableRules('avoidInjectionBefore', nextChild, additionalDetails.repeatableRules.avoidInjection.before)
            && zoneDistanceHelper.hasSpace(child, pixelDistance)
        ){

            var zoneIndex = ++this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()];

            // Create new zone.
            var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(child, placement, baseZone, zoneIndex, function(content){

                // TODO: This can be added as a function of the zone delegate.
                var debugInfo = {
                    baseZoneInfo: baseZone.zoneInfo,
                    zoneIndex: zoneIndex,                    
                    pixelDistanceRule: pixelDistance,
                    currentPixelDistance: currentPixelCount,
                };

                // TODO: Reserve space for new zone until injection is complete.
                return `
                    <div class="an-injected">
                        <!-- Info: ${JSON.stringify(debugInfo)} -->
                        ${content}
                    </div>
                `;  
            });

            var originalUnit = newZone.getOriginalUnit();

            // Add ad to auction.
            adsForAuction.push(newZone.getOriginalUnit());

            currentPixelCount = 0;

            zoneDistanceHelper.addZone(newZone, originalUnit);
        }
    }

    // After looping through all the children, check if we can inject an ad after this element and before the next element. 
    // All while maintaining a minimum spacing between zones.
    if(pixelDistance
        && target.clientHeight > 0
        && (densityManager || (!densityManager && currentPixelCount >= pixelDistance))
        && this.__validateRepeatableRules('avoidInjectionAfter', target, additionalDetails.repeatableRules.avoidInjection.after)
        && (nextTarget && this.__validateRepeatableRules('avoidInjectionBefore', nextTarget, additionalDetails.repeatableRules.avoidInjection.before))
        && zoneDistanceHelper.hasSpace(target, pixelDistance)
        && (first || (!first && zoneDistanceHelper.isElementBelowLastInjectedZone(target)))
    ){

        var zoneIndex = ++this.__numberOfInjectedZones[baseZone.zoneInfo.getKey()];

        // Create new zone.
        var newZone = this.__zoneDelegate.addNewZoneToPageFromTemplate(target, placement, baseZone, zoneIndex, function(content){
    
            // TODO: This can be added as a function of the zone delegate.
            var debugInfo = {
                baseZoneInfo: baseZone.zoneInfo,
                zoneIndex: zoneIndex,
                pixelDistanceRule: pixelDistance,
                currentPixelDistance: currentPixelCount,
            };

            // TODO: Reserve space for new zone until injection is complete.
            return `
                <div class="an-injected">
                    <!-- Info: ${JSON.stringify(debugInfo)} -->
                    ${content}
                </div>
            `;  
        });

        var originalUnit = newZone.getOriginalUnit();

        // Add ad to auction.
        adsForAuction.push(originalUnit);

        currentPixelCount = 0;

        zoneDistanceHelper.addZone(newZone, originalUnit);
    }

    return {
        adsForAuction: adsForAuction,
        currentPixelCount: currentPixelCount
    };
};

//
// Returns true if element is transparent.
ANInjector.prototype.__isElementTransparent = function(elementOfIntrest, rules){
    
    return this.__validateRepeatableRules('transparent', elementOfIntrest, rules);
};

//
// Repetable rules validator.
ANInjector.prototype.__validateRepeatableRules = function(context, elementOfIntrest, rules){
    
    var entryFoundReturnValue = false;

    if('transparent' === context){

        entryFoundReturnValue = true;
    }

    try{

        for(var i = 0; i < rules.length; i++){

            var entry = rules[i];
    
            if('tag' === entry.type && elementOfIntrest.tagName.toLowerCase() === entry.selection.toLowerCase()){
    
                return entryFoundReturnValue;
            }
            else if('class' === entry.type && elementOfIntrest.classList.contains(entry.selection)){
    
                return entryFoundReturnValue;
            }
            else if('id' === entry.type && elementOfIntrest.id === entry.selection){
    
                return entryFoundReturnValue;
            }
            else if('query' === entry.type && elementOfIntrest.matches(entry.selection)){
    
                return entryFoundReturnValue;
            }
        }
    }
    catch(error){

        this.__logger.error('Unable to verify repeatble rules.', {
            context: context,
        });
        this.__logger.error(error);
    }

    return (!entryFoundReturnValue);
};

/**
 * Returns pixel distance to use.
 * 
 * @param {number} index 
 * @param {Object} rules 
 * @param {number} currentPageDepth 
 * @param {ANDensityManager} densityManager 
 * @returns 
 */
ANInjector.prototype.__getPixelDistance = function(index, rules, currentPageDepth, densityManager = null){
    
    if(!Number.isInteger(index)
        || !rules 
        || !rules.hasOwnProperty('type') 
        || (('pixelCount' === rules.type) 
            && rules.hasOwnProperty('pixelCount') 
            && rules.hasOwnProperty('degradationStartingPoint') 
            && rules.hasOwnProperty('degradationStartingPointPlus'))
    ){

        throw new Error('Index is not an integer or missing a distance rule.');
    }

    var returnValue = null;

    if(densityManager){

        // Using ad density to determine pixel distance.
        returnValue = densityManager.determineDistanceBetweenZones(index, currentPageDepth);
    }
    else{

        // TODO: Rule "skipAds".
        // TODO: Rule "stopAds".

        if((rules.degradationStartingPointPlus && index < rules.degradationStartingPointPlus || !rules.degradationStartingPointPlus) 
            && (rules.degradationStartingPoint && index >= rules.degradationStartingPoint)
        ){

            returnValue = rules.degradationCount;
        }
        else if(rules.degradationStartingPointPlus && index >= rules.degradationStartingPointPlus){

            returnValue = rules.degradationCountPlus;
        }

        returnValue = rules.count;
    }

    // this.__logger.info('Pixel distance.', {
    //     index: index, 
    //     currentPageDepth: currentPageDepth, 
    //     pixelDistance: returnValue,
    //     densityManager: densityManager,
    // });

    return returnValue;
};

//
// Returns number of injected zones.
ANInjector.prototype.__getNumberOfInjectedZones = function(key){
    
    return this.__numberOfInjectedZones[key] || 0;
};

/**
 * Returns top Y position of element.
 * 
 * @param {HTMLElement} element 
 * @returns 
 */
ANInjector.prototype.__getTopYPosition = function(element){
    
    var rect = element.getBoundingClientRect();

    return rect.top + window.scrollY;
};

/**
 * Returns bottom Y position of element.
 * 
 * @param {HTMLElement} element 
 * @returns 
 */
ANInjector.prototype.__getBottomYPosition = function(element){
    
    var rect = element.getBoundingClientRect();

    return rect.bottom + window.scrollY;
};

/**
 * Returns height of element.
 * 
 * @param {HTMLElement} element 
 * @returns 
 */
ANInjector.prototype.__getHeight = function(element){
    
    var rect = element.getBoundingClientRect();

    return rect.height;
};

/**
 * Process queue of closures.
 */
ANInjector.prototype.processQueue = function(queue){

    // Execute all closures currently in the queue.
    while(queue.length > 0){

        var closure = queue.shift();

        try{

            closure();
        }
        catch(error){

            this.__logger.error('Error encountered while processing queue.', {
                message: error.message,
                closure: closure,
            });
            this.__logger.error(error);
        }
    }
};

/**
 * Creates or returns a density manager.
 * 
 * @param {Object} rules 
 * @returns {ANDensityManager}
 */
ANInjector.prototype.__getDensityManager = function(target, baseZone){
    
    if(!target || !(target instanceof HTMLElement)){
        
        throw new Error('Invalid target.');
    }
    else if(!baseZone){
        
        throw new Error('Invalid base zone.');
    }

    var key = baseZone.getKey();

    if(!this.__densityManagers[key]){
        
        this.__densityManagers[key] = new ANDensityManager(target, this.__zoneDelegate, baseZone, this.__logger);
    }

    return this.__densityManagers[key];
};

/**
 * Creates or returns a distance helper.
 * 
 * @param {Object} rules 
 * @returns {ANDensityManager}
 */
ANInjector.prototype.__getDistanceHelper = function(target, baseZone, rule){
    
    if(!target || !(target instanceof HTMLElement)){
        
        throw new Error('Invalid target.');
    }
    else if(!baseZone){
        
        throw new Error('Invalid base zone.');
    }
    else if(!rule || typeof rule !== 'object' || !rule.hasOwnProperty('type')){
        
        throw new Error('Invalid rule.');
    }

    var key = baseZone.getKey();

    if(!this.__distanceHelpers[key]){
        
        this.__distanceHelpers[key] = new ANInjectorZoneDistanceHelper(this.__zoneDelegate, this.__logger, target, (rule.hasOwnProperty('elementsToIgnore')) ? rule.elementsToIgnore : []);
    }

    return this.__distanceHelpers[key];
};

window.ANInjector = ANInjector;